/**
 * Ein TimetableCourse repräsentiert die Daten eines regulären Kurses in einer Stundenplanzelle.
 * Ein regulärer Kurs kann ggf. mit
 */

import { TimetableItemBase } from "./timetableItemBase";
import { groupClassNames } from "./util";

export class TimetableCourse extends TimetableItemBase{

   constructor(data, user, weekNumber) {
      super(data);
      this.user = user;
      this.data = data;
      this.weekNumber = weekNumber;
      this.course = data.course || null;
      this.classes = data.course && data.course.classes ? data.course.classes : data.classes || [];
      this.timetableId = data.id;
      this.rooms = data.rooms || [];
      this.teachers = data.teachers || [];
      this.titles = data.title ? [data.title] : [];
      this.lessonRefs = data.lessonRefs ? JSON.parse(data.lessonRefs) : {};
      this.substitutions = [];
      this.onClick = (course) => {};
   }

   clone() {
      const clone = new TimetableCourse({
         timetableId: this.timetableId,
         data: this.data,
         date: this.date,
         weekday: this.weekday,
         course: this.course,
         classes: this.classes,
         timetableId: this.timetableId,
         rooms: this.rooms,
         teachers: this.teachers,
         title: this.titles[0],
      }, this.user, this.weekNumber);

      clone.lessonRefs = this.lessonRefs;

      return clone;

   }

   render(elCourse, view, dm) {

      const cancelled = !!this.substitutions.find(s => s.cancelled)
      const rooms    = this.compileSubstitutions('rooms', this.rooms/*.map(room => dm.getRoom(room).short)*/, cancelled)
      const teachers = this.compileSubstitutions('teachers', this.teachers.map((id) => dm.getUser(id).short), cancelled);
      const titles   = this.compileSubstitutions('titles', this.titles, cancelled);

      let strRooms    = this.renderCompiled(rooms, (room) => dm.getRoom(room).short);
      let strTeachers = this.renderCompiled(teachers);
      let strTitles   = this.renderCompiled(titles);

      const classes = this.compileSubstitutions('classes', this.classes, cancelled);
      classes.regularItems = dm.classGrouper.group(classes.regularItems);
      classes.absentItems = dm.classGrouper.group(classes.absentItems);
      classes.newItems = dm.classGrouper.group(classes.newItems);
      let strClasses = this.renderCompiled(classes);

      //console.log(classes);

      const movedSubst = this.substitutions.find(subst => subst.newDate || subst.oldDate);
      const movedSymbol = movedSubst ? movedSubst.getMovedSymbol() : '';

      const message = this.substitutions.length ? this.substitutions[0].message : ''

      super.render(this, strRooms, strTeachers, strClasses, strTitles, message, movedSymbol, elCourse, this.weekNumber, view, dm);

      //console.log(this);

      if (view.type === 'teacher') {
         if (!teachers.presentItems.includes(view.short)
          //|| (classes.presentItems.length === 0 && !titles.regularItems.hasIntersectionWith(['PER', 'P1', 'P2', 'P3', 'ESL']))) {
          || (classes.absentItems.length > 0 && classes.presentItems.length === 0)) {
            elCourse.classList.add('cancelled');
            if (teachers.newItems.length > 0) {
               if (elCourse.querySelector('.title .new')) elCourse.querySelector('.title .new').innerText += ' (' + teachers.newItems.join(',') + ')';
               else  elCourse.querySelector('.title').innerHTML += ` <span class="new">(${teachers.newItems.join(',')})</span>`;
            }
         }
         //if (!teachers.newItems.includes(view.short) && teachers.absentItems.length > 0) strTitles += ` <span class="absent">(${teachers.absentItems.join(',')})</span>`;
         //if (teachers.absentItems.includes(view.short) && teachers.newItems.length > 0) strTitles += ` <span class="absent">(${teachers.newItems.join(',')})</span>`;
      }

      else if (view.type === 'pupil') {
         if (!classes.presentItems.includes(view.class.id) || cancelled) {
            elCourse.classList.add('cancelled');
         }
      }
      else if (view.type === 'room') {
         if (!rooms.presentItems.includes(view.id) || cancelled) {
            elCourse.classList.add('cancelled');
         }
      }
      else if (view.type === 'class') {

         if (!classes.presentItems.includes(view.id) || cancelled) {
            elCourse.classList.add('cancelled');
         }
      }
      else if (view.type === 'course') {
         if (cancelled) {
            elCourse.classList.add('cancelled');
         }
      }


      if (view.type !== 'teacher' && teachers.regularItems.includes(this.user.short)) {
         elCourse.classList.add('my');
      }

      elCourse.onclick = (e) => this.onClick(this);

   }

   compileSubstitutions(key, items, cancelled) {

      //console.log(items);

      const absentKey = 'absent' + key[0].toUpperCase() + key.slice(1);

      const substAbsent = [], substPresent = [];
      this.substitutions.map(subst => {
         subst[absentKey].map(abs => substAbsent.push(abs));
         subst[key].map(n => substPresent.push(n));
      });

      let regularItems = [], absentItems = substAbsent, newItems = [], presentItems = [];

      if (cancelled) {
         absentItems = items;
      }
      else {

         items.map(item => {
            if (!substAbsent.includes(item)) regularItems.push(item);
            //regularItems.push(item);
         });

         substPresent.map(item => {
            if (!items.includes(item)) newItems.push(item);
         });

         presentItems = regularItems.remove(absentItems).concat(newItems);
      }

      return { 
         regularItems: regularItems.unique(),
         absentItems:  absentItems.remove(newItems).unique(),
         newItems: newItems.unique(),
         presentItems: presentItems.unique()
      };

   }

   
   renderCompiled(comp, callback=i=>i) {

      let ret = '';
      if (comp.regularItems.length) ret += `<span class="regular">${comp.regularItems.map(callback).join(',')}</span>`;
      if (comp.absentItems.length) ret += ` <span class="absent">${comp.absentItems.map(callback).join(',')}</span>`;
      if (comp.newItems.length) ret += ` <span class="new">${comp.newItems.map(callback).join(',')}</span>`;
      return ret;

   }

   addSubstitution(subst) {
      this.substitutions.push(subst);
   }




}